import { ValidatedField } from "./ValidatedField";
import { PLACEHOLDERS, normalizeBic, validateBic } from "../validation";

/** BIC-Feld: Uppercase, Format-Validierung (8 oder 11 Stellen). */
export function BicInput({
  label,
  name,
  value,
  onChange,
  required,
}: {
  label: string;
  name: string;
  value: string;
  onChange: (v: string) => void;
  required?: boolean;
}) {
  return (
    <ValidatedField
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      placeholder={PLACEHOLDERS.bic}
      sanitize={(v) => v.toUpperCase().replace(/[^A-Z0-9]/g, "")}
      normalizeOnBlur={normalizeBic}
      validate={validateBic}
    />
  );
}

export default BicInput;
